module.exports = __webpack_public_path__ + "img/big_1_76.47eb10c7.png";